/* global graphql  */
import React from 'react'
import Helmet from 'react-helmet'
import Header from '../components/header-new'
import Footer from '../components/footer-new'
import OpenPositions from '../components/open-roles'

const CareersPage = ({ data }) => (
  <div className='wrapper--page page--careers'>
    <Helmet title='Careers - ATTN:' />
    <Header theme='dark' />
    <div className='careers__hero'>
      <img
        className='careers__hero--desktop'
        src={data.drupalMedia.image_desktop.url}
      />
      <img
        className='careers__hero--mobile'
        src={data.drupalMedia.image_mobile.url}
      />
    </div>
    <div className='careers-intro'>
      <div className='careers-intro__body'>
        We hire makers, organizers, strategists and creative leaders who are
        ready to think originally.
      </div>
    </div>
    <div className='careers-benefits wrapper--max-width'>
      <h2 className='careers-benefits__header'>Benefits at ATTN:</h2>
      <p className='careers-benefits__description'>
        We've built a robust benefits program because we value the well-being of
        our employees.
      </p>
      <div className='careers-benefits__grid'>
        <div className='careers-benefits__item'>
          <p className='careers-benefits__item-header'>Parental Leave</p>
          <p className='careers-benefits__item-description'>
            Generous paid leave for new moms and dads
          </p>
        </div>
        <div className='careers-benefits__item'>
          <p className='careers-benefits__item-header'>Health Insurance</p>
          <p className='careers-benefits__item-description'>
            Comprehensive health insurance for employees and their families
          </p>
        </div>
        <div className='careers-benefits__item'>
          <p className='careers-benefits__item-header'>401K Plan</p>
          <p className='careers-benefits__item-description'>
            Retirement plan (401k)
          </p>
        </div>
        <div className='careers-benefits__item'>
          <p className='careers-benefits__item-header'>Unlimited PTO</p>
          <p className='careers-benefits__item-description'>
            Paid time off (vacation, sick, and public holidays)
          </p>
        </div>
      </div>
    </div>
    <OpenPositions />
    <Footer />
  </div>
)

export default CareersPage

export const query = graphql`
query CareersQuery {
  drupalMedia(pid: {eq: "82"}) {
    image_desktop {
      url
    }
    image_mobile {
      url
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/pages/careers.js